import { render, staticRenderFns } from "./SportsMajor.vue?vue&type=template&id=22ac5145&scoped=true"
import script from "./SportsMajor.vue?vue&type=script&lang=js"
export * from "./SportsMajor.vue?vue&type=script&lang=js"
import style0 from "./SportsMajor.vue?vue&type=style&index=0&id=22ac5145&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac5145",
  null
  
)

export default component.exports